module.exports = __webpack_public_path__ + "static/img_1908-ba61b2904d5fd0e1a5cda98ff05728ab.webp";